export const RETRY_FETCH = 'location/RETRY_FETCH';
